<template>
<div class="chapter">
<div class="inner_page">
<p class="C73"><a id="page_ix">Contents</a></p><a id="page_ix">
</a><p class="C53"><a id="page_ix"><em></em></a><em><a href="#/xhtml/06_Translator_s_Note#page_xi">Translator’s Note</a></em></p>
<p class="C76"><a href="#/xhtml/07_1__Causa_and_Culpa#page_1">1. <em>Causa</em> and <em>Culpa</em></a></p>
<p class="C76"><span href="#/xhtml/08_2__Crimen_and_Karman#page_24" title="Link target outside of Sample">2. <em>Crimen</em> and <em>Karman</em></span></p>
<p class="C76"><span href="#/xhtml/09_3__The_Aporias_of_the_Will#page_43" title="Link target outside of Sample">3. The Aporias of the Will</span></p>
<p class="C53"><span href="#/xhtml/10_4__Beyond_Action#page_60" title="Link target outside of Sample">4. Beyond Action</span></p>
<p class="C76"><em><span href="#/xhtml/11_Bibliography#page_87" title="Link target outside of Sample">Bibliography</span></em></p>
<p class="C76"><em><span href="#/xhtml/12_Index_of_Names#page_93" title="Link target outside of Sample">Index of Names</span></em></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 05_Contents.vue?86470dca